import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import injectSheet from 'react-jss/lib/injectSheet';
import { compose } from 'redux';
import { greenhouseFilters } from '../../selectors';
import { officeFilterChangedCreator } from '../../actions';
import styles from './styles';

const Offices = ({
  greenhouse,
  filters,
  onOfficeChange,
  classes,
}) => (
  <select
    className={classes.customSelect}
    value={filters.officeId}
    onChange={e => onOfficeChange(e.target.value)}
  >
    <option value>
      All Offices
    </option>
    { greenhouse.offices.value.map(office => (
      <option value={office.id} key={office.id}>
        {office.name}
      </option>
    ))}
  </select>
);

Offices.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  filters: PropTypes.shape({
    officeId: PropTypes.number.isRequired,
  }).isRequired,
  greenhouse: PropTypes.shape({
    offices: PropTypes.shape({
      busy: PropTypes.bool.isRequired,
      error: PropTypes.bool,
      value: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
      })).isRequired,
    }),
  }).isRequired,
  onOfficeChange: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  ...state,
  filters: greenhouseFilters(state),
});

const mapDispatchToProps = dispatch => ({
  onOfficeChange: departmentId => dispatch(officeFilterChangedCreator(departmentId)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectSheet({
    ...styles,
    customSelect: {
      ...styles.customSelect,
      marginLeft: '16px',
      marginRight: '0px',
    },
  }),
)(Offices);
